export default {
  hideManageAccount: true,
  integrations: {
    availableIntegrations: [],
  },
  links: {
    hideOneDrive: true,
    hideDropbox: true,
    hideGoogleDrive: true,
    hideFileUpload: false,
  },
  availableTemplates: [],
};
